/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialogue_List_Export_Forced_SubtitlesInputs */

const en_dialogue_list_export_forced_subtitles = /** @type {(inputs: Dialogue_List_Export_Forced_SubtitlesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forced Subtitles`)
};

const fr_dialogue_list_export_forced_subtitles = /** @type {(inputs: Dialogue_List_Export_Forced_SubtitlesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sous-titres forcés`)
};

const de_dialogue_list_export_forced_subtitles = /** @type {(inputs: Dialogue_List_Export_Forced_SubtitlesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erzwungene Untertitel`)
};

const it_dialogue_list_export_forced_subtitles = /** @type {(inputs: Dialogue_List_Export_Forced_SubtitlesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sottotitoli forzati`)
};

const ru_dialogue_list_export_forced_subtitles = /** @type {(inputs: Dialogue_List_Export_Forced_SubtitlesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Принудительные субтитлы`)
};

const es_dialogue_list_export_forced_subtitles = /** @type {(inputs: Dialogue_List_Export_Forced_SubtitlesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subtítulos forzados`)
};

const zh_cn2_dialogue_list_export_forced_subtitles = /** @type {(inputs: Dialogue_List_Export_Forced_SubtitlesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`强制字幕`)
};

const ja_dialogue_list_export_forced_subtitles = /** @type {(inputs: Dialogue_List_Export_Forced_SubtitlesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`強制字幕`)
};

const hi_dialogue_list_export_forced_subtitles = /** @type {(inputs: Dialogue_List_Export_Forced_SubtitlesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`जबरन उपशीर्षक`)
};

const pt_pt2_dialogue_list_export_forced_subtitles = /** @type {(inputs: Dialogue_List_Export_Forced_SubtitlesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Legendas forçadas`)
};

/**
* | output |
* | --- |
* | "Forced Subtitles" |
*
* @param {Dialogue_List_Export_Forced_SubtitlesInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const dialogue_list_export_forced_subtitles = /** @type {((inputs?: Dialogue_List_Export_Forced_SubtitlesInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialogue_List_Export_Forced_SubtitlesInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_dialogue_list_export_forced_subtitles(inputs)
	if (locale === "de") return de_dialogue_list_export_forced_subtitles(inputs)
	if (locale === "it") return it_dialogue_list_export_forced_subtitles(inputs)
	if (locale === "ru") return ru_dialogue_list_export_forced_subtitles(inputs)
	if (locale === "es") return es_dialogue_list_export_forced_subtitles(inputs)
	if (locale === "zh-CN") return zh_cn2_dialogue_list_export_forced_subtitles(inputs)
	if (locale === "ja") return ja_dialogue_list_export_forced_subtitles(inputs)
	if (locale === "hi") return hi_dialogue_list_export_forced_subtitles(inputs)
	if (locale === "pt-PT") return pt_pt2_dialogue_list_export_forced_subtitles(inputs)
	return en_dialogue_list_export_forced_subtitles(inputs)
});